export {
  changeAPI,
  envAPI,
  getAPI,
  loadInital,
  setDefaultEnvApi,
} from './apiEndpointHelpers';

export { default as handleLogout } from './handleLogout';
export { default as requestAPI } from './requestAPI';
export {
  humanReadableDate,
  humanReadableDateWithTime,
  humanReadableDateDifference,
} from './date';

export {
  uploadFilesToS3,
  uploadFilesToS3OnlyKeys,
  type FileWithKeys,
  getFileURL,
} from './s3Upload';
export const fake_avatar_url = 'https://i.pravatar.cc/300';
